var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.53429 3.44099C1.60909 3.06702 1.97288 2.82449 2.34685 2.89929L3.31301 3.09252C4.40428 3.31077 5.22511 4.21601 5.33585 5.32337L5.41435 6.10838H17.9135C19.7404 6.10838 21.0809 7.82526 20.6378 9.59764L19.6041 13.7326C19.1686 15.4746 17.6034 16.6966 15.8079 16.6966H7.52795C6.24626 16.6966 5.16672 15.7389 5.01402 14.4663L4.10299 6.87441L3.96163 5.46079C3.91129 4.95745 3.53819 4.54598 3.04216 4.44677L2.076 4.25354C1.70203 4.17874 1.4595 3.81495 1.53429 3.44099ZM9.3931 11.9663C9.01173 11.9663 8.70257 12.2754 8.70257 12.6568C8.70257 13.0382 9.01173 13.3473 9.3931 13.3473H13.4033C13.7847 13.3473 14.0939 13.0382 14.0939 12.6568C14.0939 12.2754 13.7847 11.9663 13.4033 11.9663H9.3931Z",
    fill: "#E8C229"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.19626,
    cy: 19.2282,
    r: 1.38107,
    fill: "#E8C229"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4826,
    cy: 19.2282,
    r: 1.38107,
    fill: "#E8C229"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy);
export default __webpack_public_path__ + "static/media/buy.af5f06de4b05eea193886c760d3a0310.svg";
export { ForwardRef as ReactComponent };